import clsx from 'clsx';
import React from 'react';

interface SubscriptionStatusCheckboxProps {
  altText: string;
  className: string;
  displayText: string;
  imgSrc: string;
}

const SubscriptionStatusCheckbox = ({
  altText,
  className,
  displayText,
  imgSrc,
}: SubscriptionStatusCheckboxProps): JSX.Element => {
  return (
    <>
      <img
        src={imgSrc}
        alt={altText}
        className={clsx({ 'dark:invert-[100%]': altText === 'Not Subscribed' })}
      />
      <div className={className}>{displayText}</div>
    </>
  );
};

export default SubscriptionStatusCheckbox;
